const StyleSheet = {
  monthPicker: {
    width: '200px',
    marginBottom: 0,
    '&.Mui-filled': {
      '& .MuiPickersInputBase-root': {
        '&: not(.Mui-focused, .Mui-error, .Mui-disabled)': {
          background: 'none',
        },
      },
    },
    '& .MuiPickersInputBase-root': {
      border: 'none',
    },
    '& .MuiPickersOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputAdornment-positionStart': {
      marginRight: '6px',
    },
    '& .MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer': {
      fontSize: '16px',
      padding: 0,
    },
    '& .MuiInputAdornment-root.MuiInputAdornment-positionEnd': {
      '& .MuiSvgIcon-root': {
        width: '18px',
        height: '18px',
      },
    },
  },
};
export default StyleSheet;
